import { Component } from '@angular/core';
import {ToasterService} from "angular2-toaster";

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  providers: [ToasterService]
})
export class AppComponent {}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/app.component.ts